import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {ConfirmationService, MessageService, PrimeNGConfig, SelectItem} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {Subscription} from 'rxjs';
import {FileUsageService} from '../../../../_services/file-usage.service';
import {
    MapLocation,
    MapViewerComponent,
    AcabimSite,
    AcabimSiteUpdateRequest,
    SiteApiService,
    LandApiService,
    LocationInfo,
    MultiFileUploadComponent,
    ErrorDialogComponent, MultifileService
} from '@cas-hub/acabim-common-client';


@Component({
    selector: 'acabim-admin-edit-site-address',
    templateUrl: './edit-site-address.component.html',
    styleUrls: ['./edit-site-address.component.scss'],
    providers: [MessageService]
})
export class EditSiteAddressComponent implements OnInit {
    public siteName = '';
    groupNames: string[] = [];
    public selectedMapLocation?: MapLocation;
    public mapCoordinates?: number[][];
    groupForm: FormGroup | undefined;
    siteForm: FormGroup = new FormGroup({
        siteName: new FormControl(),
        selectedGroups: new FormControl()
    });
    groups: SelectItem[] = [];
    private _mapView?: MapViewerComponent;
    public mimetypes: string[] = [
        'application/pdf',
        'image/png',
        'image/jpeg'
    ];
    @ViewChild('fileComp') public fileComponent?: MultiFileUploadComponent;
    public fullFiles: { guid: string, name: string, loading: boolean, file: any }[] = [];
    public fileGuids: string[] = [];
    disableAdd = false;

    public get mapView(): MapViewerComponent | undefined {
        return this._mapView;
    }

    @ViewChild('mapViewer', {static: false})
    public set mapView(content: MapViewerComponent | undefined) {
        this._mapView = content;
        if (content && this.currentSite?.isLocationEditable) {
            content.activateSearchMode().then();
        }
    }

    @Input() _currentSite?: AcabimSite = undefined;
    @Output() update = new EventEmitter<boolean>();
    isLoading = false;

    public get currentSite(): AcabimSite | undefined {
        return this._currentSite;
    }

    public set currentSite(site: AcabimSite | undefined) {
        this._currentSite = site;
        console.log(this._currentSite);
        this.siteName = site ? site.name : '';
        this.selectedMapLocation = site ? {
            latitude: site.latitude,
            longitude: site.longitude,
            address: site.address
        } : undefined;
        if (site) {
            // tslint:disable-next-line:no-non-null-assertion
            this.getFiles(this._currentSite!.id);
            this.refreshMap();
        }
    }

    public get isProcessing(): boolean {
        return this._currentProcess !== undefined;
    }


    private _currentProcess?: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private readonly siteApiService: SiteApiService,
        private readonly landApiService: LandApiService,
        private readonly dialog: DialogService,
        private fb: FormBuilder,
        private readonly fileServiceCommon: MultifileService,
        private confirmationService: ConfirmationService,
        private readonly fileService: FileUsageService,
        private messageService: MessageService, private primengConfig: PrimeNGConfig
    ) {
        this.currentSite = this._currentSite;
    }

    /**
     * Called when the user has changed the Map Location
     */
    public onMapLocationChanged(location: MapLocation): void {
        this.logger.debug('[SiteComponent] Location Change Event received: ', location);
        this.selectedMapLocation = location;
        this.mapCoordinates = undefined;

        this.landApiService.getPathCoordinates(new LocationInfo(location.latitude, location.longitude))
            .subscribe(value => this.mapCoordinates = value);
    }

    public onSubmit(): void {
        if (this.isProcessing) {
            this.logger.warn('[SiteComponent] Add/Update Site already processing - cancelling request');
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Add/Update Site already processing - cancelling request'
            });
            return;
        }

        if (this._currentSite) {
            this.updateSite();
        }
    }


    private updateSite(): void {
        if (this.siteForm.get('siteName') === undefined || this.siteForm.get('siteName') === null) {
            return;
        }
        if (!this._currentSite) {
            this.logger.error('[SiteComponent] Unable to update site-and-project - No site-and-project found');
            return;
        }
        this.logger.debug('[SiteComponent] Updating site-and-project' + this._currentSite.id);

        let latitude: number | undefined;
        console.dir(this.selectedMapLocation);
        if (this.selectedMapLocation && this._currentSite.latitude !== this.selectedMapLocation.latitude) {
            latitude = this.selectedMapLocation.latitude;
        }
        let longitude: number | undefined;
        if (this.selectedMapLocation && this._currentSite.longitude !== this.selectedMapLocation.longitude) {
            longitude = this.selectedMapLocation.longitude;
        }
        let address: string | undefined;
        if (this.selectedMapLocation) {
            address = this.selectedMapLocation.address;
        }
        let siteGroups: string[] = [];
        if (this.siteForm) {
            siteGroups = this.siteForm.get('selectedGroups')?.value ?? undefined;
            console.dir(siteGroups);
            const request: AcabimSiteUpdateRequest = {
                name: this.siteForm.get('siteName')?.value ?? undefined,
                latitude,
                longitude,
                address,
                groups: siteGroups
            };
            console.dir(request);
            this._currentProcess = this.siteApiService.updateSite(this._currentSite.id, request).subscribe(_ => {
                this.update.emit(true);
                this.messageService.clear();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    // @ts-ignore
                    detail: 'Site ' + this._currentSite.name + ' has been Updated'
                });
                this.refreshMap();
                this._currentProcess = undefined;
            }, error => {
                this._currentProcess?.unsubscribe();
                this._currentProcess = undefined;
                ErrorDialogComponent.showError(error, this.dialog);
            });
        }
    }

    private refreshMap(): void {
        if (!this.currentSite) {
            return;
        }

        this.landApiService.getPathCoordinates(new LocationInfo(this.currentSite.latitude, this.currentSite.longitude))
            .subscribe(val => {
                this.mapCoordinates = val;
                if (this.mapView) {
                    this.mapView.path = this.mapCoordinates;
                    if (this.currentSite?.address) {
                        this.mapView.locationTitle = this.currentSite.address;
                        this.mapView.mapConfig = {
                            zoom: 16,
                            centerLongitude: this.currentSite.longitude,
                            centerLatitude: this.currentSite.latitude
                        };
                    }
                    this.mapView.refreshMapView().then(r => {
                    });
                }
            });
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;

        this.groupForm = this.fb.group({
            selectedGroups: ['', Validators.nullValidator]
        });
        this.siteApiService.getAllSiteGroups().subscribe(data => {
            console.log(data);
            if(data && data.data) {
                data.data.map(d => {
                    this.groups.push({label: d.name, value: d.id});

                });
            }
        });
        const selectGroups: string[] = [];
        if (this._currentSite !== undefined) {
            this._currentSite.groups.map(g => {
                selectGroups.push(g.id);
                this.groupNames.push(g.name);
            });
            this.siteForm = new FormGroup({
                siteName: new FormControl(this._currentSite.name),
                selectedGroups: new FormControl(selectGroups)
            });
            this.siteForm.get('selectedGroups')?.valueChanges.subscribe(v => {
                this.groupNames = [];
            });
        }
        // @ts-ignore
        // this.groupForm.get('selectedGroups').setValue(selectGroups);

        this.currentSite = this._currentSite;
        this.refreshMap();
    }

    addImages(): void {
        this.isLoading = true;
        // tslint:disable-next-line:no-non-null-assertion
        this.fileService.uploadFile(this.currentSite!.id, this.fileGuids, 'site').subscribe(data => {
            this.fileGuids = [];
            this.fullFiles = [];
            this.fileComponent?.resetImages();
            this.isLoading = false;
            // tslint:disable-next-line:no-non-null-assertion
            this.getFiles(this.currentSite!.id);
            this.messageService.clear();
            this.messageService.add({
                key: 'attachment',
                severity: 'success',
                summary: 'attachments added'
            });
        }, error => {
            this.isLoading = false;
            this.messageService.clear();
            this.messageService.add({
                key: 'attachment',
                severity: 'error',
                summary: 'Sorry, cannot proceed with current attachments'
            });
        });
    }

    getFiles(buildGUID: string): void {
        this.fileService.getFilesFromObject(buildGUID, 'site').subscribe(files => {
            files.forEach(f => {
                const attachment = f.guid;
                const index = this.fullFiles.length;
                this.fullFiles.push({guid: attachment, name: f.name, loading: true, file: null});
                this.fileServiceCommon.getFile(attachment).subscribe(file => {
                    const reader = new FileReader();
                    reader.addEventListener('load', () => {
                        this.fullFiles[index].file = reader.result;
                    }, false);

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                    this.fullFiles[index].loading = false;
                }, error => {
                    this.fullFiles[index].loading = false;
                });
            });
        });
    }


    onFileAdded(guid: string): void {
        this.fileGuids.push(guid);
    }

    onFileDeleted(guid: string): void {
        this.deleteFile(guid);
    }

    deleteFile(guid: string): void {
        this.fileGuids.splice(this.fileGuids.indexOf(guid), 1);
        // tslint:disable-next-line:no-non-null-assertion
        this.fileService.removeFiles(this.currentSite!.id, [guid], 'site').subscribe(data => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'success',
                summary: 'Attachment removed'
            });
        }, error => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot remove attachment'
            });
        });
    }

    addToBuilding(): void {
        if (this.fileGuids.length > 0) {

            this.confirmationService.confirm({
                key: 'confirmAttachment',
                message: 'Would you like to proceed?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.addImages();
                },
                reject: () => {
                }
            });
        }
    }

    onFileLoading($event: boolean) {
        this.disableAdd = $event;
    }
}
